import { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useStore } from './store/useStore';
import Layout from './components/Layout/Layout';
// Lazy-loaded pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const LawyerProfilePage = lazy(() => import('./pages/LawyerProfilePage'));
const FirmProfilePage = lazy(() => import('./pages/FirmProfilePage'));
const LicenseVerificationPage = lazy(() => import('./pages/LicenseVerificationPage'));
const TestSlugsPage = lazy(() => import('./pages/TestSlugsPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const TermsOfUsePage = lazy(() => import('./pages/TermsOfUsePage'));
const LegalDisclaimerPage = lazy(() => import('./pages/LegalDisclaimerPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
// Removed sitemap page

function App() {
  const { theme, loadLawyersData } = useStore();

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  // Load lawyers data asynchronously after initial render
  useEffect(() => {
    loadLawyersData();
  }, [loadLawyersData]);

  return (
    <Router>
      <div className="App">
        <Suspense fallback={<div className="p-8 text-center">Loading…</div>}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              {/* Support both slug and ID for lawyer profiles */}
              <Route path="lawyer/:id" element={<LawyerProfilePage />} />
              {/* Support both slug and ID for firm profiles */}
              <Route path="firm/:id" element={<FirmProfilePage />} />
              <Route path="verify-license" element={<LicenseVerificationPage />} />
              <Route path="consultation" element={<div>Free Consultation Page</div>} />
              <Route path="test-slugs" element={<TestSlugsPage />} />
              <Route path="privacy" element={<PrivacyPolicyPage />} />
              <Route path="terms" element={<TermsPage />} />
              <Route path="terms-of-use" element={<TermsOfUsePage />} />
              <Route path="legal-disclaimer" element={<LegalDisclaimerPage />} />
              {/* Catch all unmatched routes */}
              <Route path="*" element={<NotFoundPage />} />
              {/* sitemap route removed */}
            </Route>
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;